export const VERSION = "0.12.0";
export const TOKEN_VERSION = 3;
export const WEB_VERSION = "0.2.0";

export const BASE_URL = "https://planepals.app";
export const DOWNLOAD_URL =
  "https://forums.x-plane.org/index.php?/files/file/92102-plane-pals-online-multiplayer/";
export const DISCORD_URL = "https://discord.gg/jAWk865MpG";

export const MAX_PLAYER_NAME_LENGTH = 15;

export const RATINGS = [
  "BUTTER!",
  "GREAT LANDING!",
  "ACCEPTABLE",
  "HARD LANDING!",
  "* WASTED! *",
];

export const FLIGHT_SAMPLE_INDEX = {
  TIMESTAMP: 0,
  LAT: 1,
  LON: 2,
  ALT: 3,
  ALT_AGL: 4,
  HEADING: 5,
  BANK: 6,
  PITCH: 7,
  SPEED: 8,
  ON_GROUND: 9,
  SIM_SPEED: 10,
  VX: 11,
  VY: 12,
  VZ: 13,
};

export const GUILD_ID = "1267296983895244820";

export const CHANNELS = {
  GENERAL: "1267296984436314115",
  BOT: "1278842539809439804",
};

export const MEMBER_ROLES = {
  Pilot: "1274895067827671212",
  FirstOfficer: "1345257383341064273",
  Captain: "1345258229264945223",
  SeniorCaptain: "1345258348211212358",
};
